import { find } from 'lodash'

import {
  SET_AVAILABLE_DATES,
  SET_START_DATE,
  SET_END_DATE
} from './mutations'

const module = 'DATE_RANGE_'

export const INIT_DATE_RANGE = module + 'initDateRange'
export const UPDATE_START_DATE = module + 'updateStartDate'
export const UPDATE_END_DATE = module + 'updateEndDate'

export default {
  [INIT_DATE_RANGE] ({ commit, state }, configDates) {
    commit(SET_AVAILABLE_DATES, configDates)
    commit(SET_START_DATE, state.availableDates[Math.max(state.availableDates.length - 12, 0)])
    commit(SET_END_DATE, state.availableDates[state.availableDates.length - 1])
  },
  [UPDATE_START_DATE] ({ dispatch, commit, state }, startDateFrom) {
    commit(SET_START_DATE, find(state.availableDates, date => date.from === startDateFrom))
  },
  [UPDATE_END_DATE] ({ dispatch, commit, state }, endDateTo) {
    commit(SET_END_DATE, find(state.availableDates, date => date.to === endDateTo))
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/dateRange/store/actions.js